// @flow
import Sales from './SalesByGroupComplexes';
import { dataKey } from './dataKey';


export default Sales;
export { dataKey };
